<template>
  <div :class="['dots-loader', color]">
    <div class="dot1 mr-2"></div>
    <div class="dot2 mr-2"></div>
    <div class="dot3"></div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'text-secondary'
    }
  }
}
</script>

<style scoped>
.dots-loader {
  margin: 0 auto;
  width: 60px;
  text-align: center;
}

.dots-loader > div {
  background-color: currentColor;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  display: inline-block;
  animation: bouncedelay 1.4s infinite ease-in-out both;
}

.dot1 {
  animation-delay: -0.32s !important;
}

.dot2 {
  animation-delay: -0.16s !important;
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
</style>
